/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-23 20:23:54 */

const Keys = { bookings: 'bookings', profile: 'profile', logout: 'logout' }; export default Keys;